const VIEW_DOMAIN_NAME = "domainName";
const VIEW_CURRENT_DOMAIN = "currentDomain";
const VIEW_CONFIRM = "confirm";
const VIEW_COMPLETE = "complete";

const STATIC_IP = "75.101.134.27";
export const DNS_RECORD_A = "A";
const DNS_RECORD_CNAME = "CNAME";

const viewDescriptions = {};

viewDescriptions[VIEW_DOMAIN_NAME] = {
  desc: "Domain Name Information",
};

viewDescriptions[VIEW_CURRENT_DOMAIN] = {
  desc: "Current Domain Settings",
};

viewDescriptions[VIEW_CONFIRM] = {
  desc: "Confirm",
};

viewDescriptions[VIEW_COMPLETE] = {
  desc: "Finish",
};

const DomainSetupConstants = {
  VIEW_DOMAIN_NAME: VIEW_DOMAIN_NAME,
  VIEW_CURRENT_DOMAIN: VIEW_CURRENT_DOMAIN,
  VIEW_CONFIRM: VIEW_CONFIRM,
  VIEW_COMPLETE: VIEW_COMPLETE,

  SETUP_FLOW_NO_BLOG: [VIEW_DOMAIN_NAME, VIEW_CURRENT_DOMAIN, VIEW_CONFIRM, VIEW_COMPLETE],

  SETUP_FLOW_BLOG: [VIEW_DOMAIN_NAME, VIEW_CURRENT_DOMAIN, VIEW_CONFIRM, VIEW_COMPLETE],

  VIEW_DESCRIPTIONS: viewDescriptions,

  DOMAIN_CONFIG_EMAIL_ONLY: "Y",
  DOMAIN_CONFIG_BLOG_ONLY: "B",
  DOMAIN_CONFIG_EMAIL_BLOG: "E",
  DOMAIN_CONFIG_NONE: "N",
  DOMAIN_CONFIG_WORDPRESS: "W",

  WEBSITE_TYPE_NONE: "None",
  WEBSITE_TYPE_CUSTOM: "Custom",
  WEBSITE_TYPE_TEMPLATE: "Template",

  DOMAIN_TYPE_PRIMARY: "primary",

  DNS_REGISTRAR_HELP: [
    {
      record: DNS_RECORD_A,
      name: "@",
      value: STATIC_IP,
    },
    {
      record: DNS_RECORD_A,
      name: "*",
      value: STATIC_IP,
    },
    {
      record: DNS_RECORD_CNAME,
      name: "www",
    },
  ],
};

export default DomainSetupConstants;
